import { ComponentProps, RefObject, useRef } from 'react'
import { ImperativePanelHandle, Panel } from 'react-resizable-panels'

import { AI_PANEL_SIZE_TRANSITION_CLASSNAME, TRANSCRIPT_PANEL_MIN_WIDTH } from 'src/components/constants'
import { ResponsiveContainerProvider } from 'src/contexts/ResponsiveContainerContext'
import { useResponsive } from 'src/hooks/useResponsive'

import * as S from './styles'

export const TRANSCRIPT_PANEL_ID = 'transcript-panel'

type TranscriptPanelProps = Pick<ComponentProps<typeof Panel>, 'onResize' | 'children'> & {
    containerWidth: number
    ref: RefObject<ImperativePanelHandle | null>
    animateSize?: boolean
}

export const TranscriptPanel = (props: TranscriptPanelProps) => {
    const { ref, onResize, children, containerWidth, animateSize = false } = props
    const { isMobilePhone } = useResponsive()
    const containerRef = useRef<HTMLDivElement>(null)

    return (
        <Panel
            id={TRANSCRIPT_PANEL_ID}
            ref={ref}
            onResize={onResize}
            className={animateSize ? AI_PANEL_SIZE_TRANSITION_CLASSNAME : undefined}
            style={!isMobilePhone ? { minWidth: TRANSCRIPT_PANEL_MIN_WIDTH } : undefined}>
            <S.TranscriptPanelContainer ref={containerRef}>
                <ResponsiveContainerProvider containerWidth={containerWidth} containerRef={containerRef}>
                    {children}
                </ResponsiveContainerProvider>
            </S.TranscriptPanelContainer>
        </Panel>
    )
}
